import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Loading} from '../lib/index';
import API from '../api';
import OptionsStep from "./OptionsStep";
import Button from "../lib/components/Button";
import dateFormat from "dateformat";
import {dateFormatsLocations} from "../constants/dateFormatsLocations";
import Bubble from '../lib/steps_components/text/Bubble';
import TextStepContainer from "../lib/steps_components/text/TextStepContainer";
import ImageContainer from "../lib/steps_components/text/ImageContainer";
import Image from "../lib/steps_components/text/Image";

class ChooseApp extends Component {
    constructor(props) {
        super(props);
        const {store} = props;
        const {texts} = store.settings;
        this.state = {
            loading: true,
            trigger: false,
            appointments: [],
            chooseForList: {
                cancel:texts.selectAppointmentYouWantCancel,
                reschedule:texts.selectAppointmentYouWantReschedule,
            }
        };
    }

    componentWillMount() {
        const {store} = this.props;
        const {settings} = store;

        dateFormat.i18n = dateFormatsLocations[settings.language];
        const params = {
            patient_id: store.patient.id
        };
        API.get('/getFutureAppointments', {params}).then((res) => {
            const result = res.data;
            var appointments = [];
            if (result.status == "success") {
                if (result.data.length > 0) {
                    result.data.forEach(function (item, i, arr) {
                        let date_arr = item.start.split(/[- :]/),
                        current_date = new Date(date_arr[0], date_arr[1]-1, date_arr[2], date_arr[3], date_arr[4], date_arr[5]);
                        let appData = dateFormat(current_date, "dddd, d mmm HH:MM ");
                        appointments.push({value: item, label: appData + ' - ' + item.services});
                    });
                    this.setState(
                        {appointments: appointments},
                        () => {
                            this.setState(
                                {loading: false}
                            );
                        }
                    );
                } else {
                    this.setState(
                        {loading: false}
                    );
                }
            }

        }).catch((error) => {
            this.setState({
                error: 'Error retrieving data',
                loading: false
            });
        });
    }

    contactClinic = () => {
        const {store} = this.props;
        const {texts} = store.settings;
        this.props.triggerNextStep({
            value: true,
            userAnswer: texts.contactClinic,
            trigger: 'contactUs_start',
        });
    };

    makeAppointment = () => {
        const {store} = this.props;
        const {texts} = store.settings;
        this.props.triggerNextStep({
            value: true,
            userAnswer: texts.makeAppointment,
            trigger: 'getServices_ask',
        });
    };


    render() {
        const {loading, appointments,chooseForList} = this.state;
        const {
            step, store, isFirst,
            isLast,
            isRTL,
            chooseFor,
            bubbleStyle,
            avatarStyle,
            hideBotAvatar,
            hideUserAvatar, botAvatar
        } = this.props;
        const {avatar, user} = step;
        const showAvatar = user ? !hideUserAvatar : !hideBotAvatar;
        const {texts} = store.settings;

        return (
            <div>
                {loading ? (
                    <Loading/>
                ) : (
                    (appointments.length > 0) ? (
                        <div>
                            <div style={{
                                marginLeft: "-22px",
                                marginRight: "-22px"
                            }}>
                                <TextStepContainer className={`rsc-ts ${user ? 'rsc-ts-user' : 'rsc-ts-bot'}`}
                                                   user={user}>
                                    <ImageContainer className="rsc-ts-image-container" user={user}>
                                        {
                                            <Image
                                                className="rsc-ts-image"
                                                style={avatarStyle}
                                                showAvatar={true}
                                                user={user}
                                                src={botAvatar}
                                                alt="avatar"
                                            />
                                        }
                                    </ImageContainer>
                                    <Bubble
                                        className="rsc-ts-bubble"
                                        style={bubbleStyle}
                                        user={user}
                                        showAvatar={false}
                                        isFirst={isFirst}
                                        isLast={isLast}
                                        isRTL={isRTL}
                                    >
                                        {chooseForList[chooseFor]}
                                    </Bubble>
                                </TextStepContainer>
                            </div>
                        <OptionsStep
                            options={appointments}
                            step={step}
                            speak={false}
                            triggerNextStep={this.props.triggerNextStep}
                        />
                        </div>) : (
                        <div>
                            <div style={{
                                marginLeft: "-22px",
                                marginRight: "-22px"
                            }}>
                                <TextStepContainer className={`rsc-ts ${user ? 'rsc-ts-user' : 'rsc-ts-bot'}`}
                                                   user={user}>
                                    <ImageContainer className="rsc-ts-image-container" user={user}>
                                        {

                                            <Image
                                                className="rsc-ts-image"
                                                style={avatarStyle}
                                                showAvatar={true}
                                                user={user}
                                                src={botAvatar}
                                                alt="avatar"
                                            />

                                        }
                                    </ImageContainer>
                                    <Bubble
                                        className="rsc-ts-bubble"
                                        style={bubbleStyle}
                                        user={user}
                                        showAvatar={false}
                                        isFirst={isFirst}
                                        isLast={isLast}
                                        isRTL={isRTL}
                                    >{texts.noAppointmentsToCancel}
                                    </Bubble>
                                </TextStepContainer>
                            </div>
                            <Button onClick={() => this.contactClinic()}>
                                {texts.contactClinic}
                            </Button>
                            <br/>
                            <Button onClick={() => this.makeAppointment()}>
                                {texts.makeAppointment}
                            </Button>
                        </div>)
                )}
            </div>
        );
    }
}

ChooseApp.propTypes = {
    steps: PropTypes.object,
    triggerNextStep: PropTypes.func,
};

ChooseApp.defaultProps = {
    steps: undefined,
    triggerNextStep: undefined,
};


export default ChooseApp;
